import React from 'react';
import Slider from 'react-slick';
import SlideCard from './SlideCard';
import InternalSlideCard from './InternalSlideCard';
const InternalSlidePage = ({ images }) => {
	const settings = {
		dots: true,
		dotsClass: 'slick-dots slick-thumb',
		infinite: true,
		speed: 2000,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		accessibility: false,
		afterChange: function (index) {
			// if (index + 1 === 3) {
			// 	setInterval(function () {
			// 		dispatch(toggleOnBoard(false));
			// 	}, 3000);
			// }
		},
	};

	return (
		<>
			<Slider {...settings} style={{ overflowX: 'hidden' }}>
				{images.map((i) => {
					return (
						<InternalSlideCard
							img={i}
							title='Manage Your Bills & Invoice  '
							title2='At One Place'
						/>
					);
				})}
			</Slider>
		</>
	);
};
export default InternalSlidePage;
